import { AgentPageContext } from '../../types/agentHarness';
import { oscarPageContextFor } from './OscarPageContext';

/**
 * A question handed to Oscar from anywhere in the app — an entity's ask box, a "Compare bids"
 * chip, and so on. The dock opens its drawer and sends it.
 */
export interface OscarInvocation {
	prompt: string;
	/**
	 * The record(s) the question is about. Omitted: the current page's record, captured when
	 * `callOscar` is called — not when the dock gets round to sending it, by which time the user may
	 * have navigated. `null`: no record. Either way the drawer's Share switch can turn it off.
	 */
	context?: AgentPageContext | null;
}

type OscarInvocationListener = (invocation: OscarInvocation) => void;

let listener: OscarInvocationListener = null;

/** Registered by `OscarDock`. Returns the unsubscribe. */
export const onCallOscar = (nextListener: OscarInvocationListener): (() => void) => {
	listener = nextListener;
	return () => {
		if (listener === nextListener) listener = null;
	};
};

export const callOscar = (invocation: OscarInvocation): void => {
	if (!listener) return;
	if (invocation.context !== undefined) {
		listener(invocation);
		return;
	}
	const pageContext = oscarPageContextFor(window.location.pathname);
	listener({ ...invocation, context: pageContext ? pageContext.context : null });
};
